import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ListingCard from '../components/ListingCard';
import PropertyMap from '../components/PropertyMap';

export default function ResultsPage() {
  const navigate = useNavigate();
  const [results, setResults] = useState<any>(null);
  const [activeTab, setActiveTab] = useState<'list' | 'map'>('list');

  useEffect(() => {
    const stored = sessionStorage.getItem('searchResults');
    if (!stored) {
      navigate('/');
      return;
    }
    try {
      setResults(JSON.parse(stored));
    } catch {
      navigate('/');
    }
  }, []);

  if (!results) {
    return (
      <div className="loading-page">
        <div className="spinner" />
        <p>Ergebnisse werden geladen...</p>
      </div>
    );
  }

  const { topMatches, nearMisses, stats } = results;
  const allListings = [...(topMatches || []), ...(nearMisses || [])];

  return (
    <div className="results-page">
      {/* Stats bar */}
      <div className="results-stats">
        <span className="stat">
          <strong>{stats?.total || 0}</strong> Immobilien geprüft
        </span>
        <span className="stat stat--pass">
          <strong>{stats?.matched || 0}</strong> Top-Treffer
        </span>
        <span className="stat stat--near">
          <strong>{stats?.nearMiss || 0}</strong> Beinahe-Treffer
        </span>
        <span className="stat stat--fail">
          <strong>{stats?.excluded || 0}</strong> ausgeschlossen
        </span>
      </div>

      {/* Mobile tab switcher */}
      <div className="mobile-tabs">
        <button
          className={`tab-btn ${activeTab === 'list' ? 'tab-btn--active' : ''}`}
          onClick={() => setActiveTab('list')}
        >
          Liste
        </button>
        <button
          className={`tab-btn ${activeTab === 'map' ? 'tab-btn--active' : ''}`}
          onClick={() => setActiveTab('map')}
        >
          Karte
        </button>
      </div>

      {/* Split view */}
      <div className="split-view">
        {/* Left: Listing cards */}
        <div className={`results-list ${activeTab === 'map' ? 'results-list--hidden-mobile' : ''}`}>
          {topMatches?.length > 0 && (
            <>
              <h2 className="results-section-title">Top-Treffer</h2>
              {topMatches.map((listing: any) => (
                <ListingCard
                  key={listing.id}
                  listing={listing}
                  onClick={() => navigate(`/listing/${listing.id}`)}
                />
              ))}
            </>
          )}

          {nearMisses?.length > 0 && (
            <>
              <h2 className="results-section-title results-section-title--near">Beinahe-Treffer</h2>
              {nearMisses.map((listing: any) => (
                <ListingCard
                  key={listing.id}
                  listing={listing}
                  onClick={() => navigate(`/listing/${listing.id}`)}
                />
              ))}
            </>
          )}

          {topMatches?.length === 0 && nearMisses?.length === 0 && (
            <div className="no-results">
              <h2>Keine Treffer gefunden</h2>
              <p>Versuchen Sie, Ihre Kriterien anzupassen.</p>
              <button className="btn btn--primary" onClick={() => navigate('/')}>
                Neue Suche starten
              </button>
            </div>
          )}
        </div>

        {/* Right: Map */}
        <div className={`results-map ${activeTab === 'list' ? 'results-map--hidden-mobile' : ''}`}>
          <PropertyMap listings={allListings} />
        </div>
      </div>
    </div>
  );
}
